import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import { initReactI18next } from 'react-i18next'
import XHR from 'i18next-xhr-backend'
import languageEN from './locales/en/translation.json'
import languageAr from './locales/ar/translation.json'
const resources = {
  en: {
    translation: languageEN,
  },
  ar: {
    translation: languageAr,
  },
}
i18n
  .use(XHR)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    lng: localStorage.getItem('i18nextLng'),
    fallbackLng: 'en',
    debug: false,
    keySeparator: '.',
    interpolation: {
      escapeValue: false,
      formatSeparator: ',',
    },
    whitelist: ['ar', 'en'],
    react: {
      wait: true,
      bindI18n: 'languageChanged loaded',
      bindStore: 'added removed',
      nsMode: 'default',
      useSuspense: false,
    },
  })

export default i18n
